

























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GQL_yearlyReportForEmployee_yearlyReportForEmployee } from '@/queries/__generated__/yearlyReportForEmployee';
import DocumentPage from '@/components/Invoicing/Shared/DocumentPage.vue';
import DocumentLogo from '@/components/Invoicing/Shared/DocumentLogo.vue';
import formatAmount from '@/filters/formatAmount';
import orMinus from '@/filters/orMinus';
import { GQL_unitPaycheckSetting_currentUnit, GQL_unitPaycheckSetting_currentUnit_unitSetting_logo } from '@/queries/__generated__/unitPaycheckSetting';
import EmployeeInfo from './EmployeeInfo.vue';
import CompanyInfo from './CompanyInfo.vue';
import PaycheckSummary from './PaycheckSummary.vue';
import { GQL_PaycheckLineCalculationTypeEnum } from '@/queries/global';
import { GQL_yearlyReportForEmployeeWorkRelations_unit_employees_workRelations } from '@/queries/__generated__/yearlyReportForEmployeeWorkRelations';
import Decimal from '@/utils/decimal';
import { GQL_paychecksByYear_paychecksByYear } from '@/queries/__generated__/paychecksByYear';
import { uniq } from 'lodash';

@Component({
  components: {
    DocumentPage,
    DocumentLogo,
    EmployeeInfo,
    CompanyInfo,
    PaycheckSummary,
  },
})
export default class WorkRelationReport extends Vue {
  @Prop({ type: Object, required: true }) private company!: GQL_unitPaycheckSetting_currentUnit;
  @Prop({ type: Object, required: true }) private workRelation!: GQL_yearlyReportForEmployeeWorkRelations_unit_employees_workRelations;
  @Prop({ type: Array, required: true }) private reportLines!: GQL_yearlyReportForEmployee_yearlyReportForEmployee[];
  @Prop({ type: Number, required: true }) private year!: number;
  @Prop({ type: Array, required: true }) private paidPaychecks!: GQL_paychecksByYear_paychecksByYear[];
  @Prop({ type: Array, required: true }) private unpaidPaychecks!: GQL_paychecksByYear_paychecksByYear[];

  private get logo(): GQL_unitPaycheckSetting_currentUnit_unitSetting_logo {
    return this.company.unitSetting.logo;
  }

  private formatAmount = formatAmount;
  private orMinus = orMinus;

  private get sum(): Decimal {
    return this.reportLines
      .filter(line => line.calculationType === GQL_PaycheckLineCalculationTypeEnum.CASHEDOUT)
      .reduce((sum, line) => sum.add(line.sum), new Decimal(0));
  }

  private get totalVacationMoneyBase(): Decimal {
    return this.reportLines
      .reduce((sum, line) => sum.add(line.vacationMoneyBaseAmount), new Decimal(0));
  }

  private get paycheckLineDescriptions(): string[] {
    return uniq(
      [ ...this.paidPaychecks, ...this.unpaidPaychecks ]
        .flatMap(p => p.paycheckLines.filter(pl => !pl.sum.equals(0)).map(pl => pl.description)),
    );
  }

  get yearlyGrossSalary(): Decimal {
    return this.paidPaychecks
      .flatMap(paycheck => paycheck.paycheckLines)
      .filter(pl => pl.sum.greaterThan(0))
      .reduce((sum, pl) => sum.plus(pl.sum), new Decimal(0));
  }
}
